import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-button-toast',
    templateUrl: './button-toast.component.html',
    styleUrls: ['./button-toast.component.scss'],
    imports: [CommonModule]
})
export class ButtonToastComponent {
  testSuccess = { ok: true, msg: '', show: false, title: '' };

  constructor() {}

  public closeAlertDelay(): void {
    setTimeout(() => {
      this.testSuccess.show = false;
    }, 3500);
  }

  public hide(): void {
    this.testSuccess.show = false;
  }
}
